// extracted by mini-css-extract-plugin
module.exports = {"logo":"competitorLogo__logo___146on"};